module.exports = __webpack_public_path__ + "img/servicecong.a54c9f54.png";